import { OPTIN_ITEM_API, getOptInItemPostPath } from 'modules/stores/api/stores-api'
import {
  OptinItemUpdateType,
  OptinItemViewType,
} from 'modules/stores/store/content/optin/types/optin-interface'
import { usePublisherErrorHandler } from 'modules/stores/store/hooks/use-publisher-error-handler'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useOptinActions = () => {
  const { internalErrorHandler } = usePublisherErrorHandler()

  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, OptinItemViewType>({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })

  const { fetcher: putFetcher } = useFetch<RequestMethodsEnum.put, OptinItemViewType>({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })

  const { fetcher: deleteFetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })

  const createOptin = (storeId: StoreId, data: OptinItemUpdateType) =>
    postFetcher(getOptInItemPostPath(storeId), data)

  const updateOptin = (id: number, data: OptinItemUpdateType) =>
    putFetcher(`${OPTIN_ITEM_API}/${id}`, data)

  const deleteOptin = (id: number) => deleteFetcher(`${OPTIN_ITEM_API}/${id}`)

  return { createOptin, updateOptin, deleteOptin }
}
